<template>
  <div id="app">
    <!-- v-if="apiBaseUrl != 'https://clientmlbb.chuang-games.com'" -->
    <router-view/>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters(['language'])
  },
  data() {
    return {
      apiBaseUrl: process.env.VUE_APP_API_BASE_URL
    }
  },
  created() {
    console.log(this.apiBaseUrl);
    
    if(this.language != '') {
      this.$store.commit('changeLanguage', this.language)
    } else {
      // 获取浏览器默认语言
      const browserLang = navigator.language || navigator.userLanguage;
      let defaultLang = 'tw'; // 默认设置为英语
      
      // 支持的语言映射
      const supportedLanguages = {
        'zh': 'zh',        // 中文
        'zh-CN': 'zh',     // 简体中文
        'zh-TW': 'zh',     // 繁体中文
        'zh-HK': 'zh',     // 香港繁体
        'en': 'en',        // 英语
        'en-US': 'en',     // 美式英语
        'en-GB': 'en',     // 英式英语
        'in': 'in',        // 印尼语
        'id': 'in',        // 印尼语（id是印尼语的ISO代码）
        'th': 'th',        // 泰语
        'fil': 'fi',        // 菲律宾语
        'tl': 'fi',        // 菲律宾语
      };
      
      // 检查完整语言代码
      if (supportedLanguages[browserLang]) {
        defaultLang = supportedLanguages[browserLang];
      } else {
        // 检查语言代码的前两位
        const langPrefix = browserLang.split('-')[0];
        if (supportedLanguages[langPrefix]) {
          defaultLang = supportedLanguages[langPrefix];
        }
      }
      this.$store.commit('changeLanguage', defaultLang);
    }
  }
}
</script>
